module.exports = __webpack_public_path__ + "static/img/icon-blog.f4baf8c1.svg";